'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UserFeedback = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

require('@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css');

require('@ta-interaktiv/semantic-ui/semantic/dist/components/label.css');

require('@ta-interaktiv/semantic-ui/semantic/dist/components/table.css');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
/**
 * Appends stars and returns the event when clicking on them
 * @module UserFeedback
 *
 * @version 1.0
 */

require('../style/styles.css');

/**
 * New component documentation
 */

var UserFeedback = exports.UserFeedback = function (_React$Component) {
  _inherits(UserFeedback, _React$Component);

  function UserFeedback() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, UserFeedback);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = UserFeedback.__proto__ || Object.getPrototypeOf(UserFeedback)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      activeStar: -1
    }, _this.onMouseLeave = function () {
      _this.setState({
        activeStar: -1
      });
    }, _this.onMouseEnter = function (event) {
      _this.setState({
        activeStar: event.currentTarget.getAttribute('data-starIterationCount')
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(UserFeedback, [{
    key: 'render',
    value: function render() {
      var starArray = [];
      var additionalHalfStar = false;
      var floorStars = 0;
      // Check if rating contains half stars or not
      if (this.props.averageRating >= 1) {
        floorStars = parseInt(Math.floor(this.props.averageRating));
        if (this.props.averageRating - floorStars >= 0.25 && this.props.averageRating - floorStars <= 0.75) {
          additionalHalfStar = true;
        }
        if (this.props.averageRating - floorStars >= 0.75) {
          floorStars = floorStars + 1;
        }
      }
      // Check if rating is set from Question component and also check for MouseOver
      for (var i = 0; i < this.props.starAmount; i++) {
        var starClass = 'empty';
        if (this.state.activeStar >= i || this.props.rating >= i) {
          starClass = '';
        }
        if (this.props.votingIsOver) {
          starClass = 'over';
          if (floorStars <= i) {
            starClass = 'over empty';
            if (additionalHalfStar && i === floorStars) {
              starClass = 'over half empty';
            }
          }
        }
        starArray.push(_react2.default.createElement('i', {
          key: 'star-' + i,
          onClick: this.props.clickHandler,
          'data-starNumber': i + 1,
          'data-starIterationCount': i,
          onMouseLeave: this.onMouseLeave,
          onMouseEnter: this.onMouseEnter,
          className: 'ui icon ' + starClass + ' ' + this.props.starIcon + ' ' + this.props.starColor + ' ' + (this.props.votingIsOver ? '' : ''),
          style: {
            color: this.props.starColor.indexOf('#') === 0 ? this.props.starColor : ''
          }
        }));
      }
      return _react2.default.createElement(
        'div',
        {
          className: 'stars ' + this.props.className
        },
        starArray,
        this.props.votingIsOver && this.props.averageRating && _react2.default.createElement(
          'p',
          {
            className: 'ui big label average ' + (this.props.theme === 'simple' ? 'simple' : '') + ' ' + (this.props.inverted ? 'inverted' : ''),
            style: {
              color: this.props.fontColor,
              fontFamily: 'Benton Sans Cond'
            }
          },
          _react2.default.createElement(
            'span',
            { className: 'average label' },
            '\xD8 ',
            (Math.round(this.props.averageRating * 10) / 10).toFixed(1).toString().replace('.', ',')
          )
        )
      );
    }
  }]);

  return UserFeedback;
}(_react2.default.Component);

exports.default = UserFeedback;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ta-interaktiv/react-user-feedback/dist/stars.js
// module id = 360
// module chunks = 0